import Location from '@r6digital/rapidstor-types/react/entities/Location';
import { RapidStorErrorResponse } from '@r6digital/rapidstor-types/types/Api';

import Logger, { LogTags } from '@/core/utils/logging';

export default class BaseService {
    public _location: Location;

    constructor(location: Location) {
        this._location = location;
    }

    handleError = (message: string, error: string, tags?: LogTags[]) => {
        const tagsArray = tags || [];
        const errorObj = JSON.parse(error) as RapidStorErrorResponse;
        if (errorObj !== undefined) {
            tagsArray.push({
                name: 'operation_result',
                value: errorObj.operation_result,
            });
            tagsArray.push({
                name: 'operation_message',
                value: errorObj.operation_message,
            });
        }

        Logger.error(`${message}: ${error}`, this._location, tagsArray);
    };
}
